import request from '../../utils/request'
const urlParams = process.env.VUE_APP_HGJLogin
export default {
  // 好管家免登
  userDDlogin(data) {
    const params = data
    return request({
      url: urlParams + '/buyHousePC/zzd/getZzdUserPhone',
      type: 'post',
      params: params
    })
  },
  
}